import { Routes } from '@angular/router';
import { AuthClientCryptoGuard } from './core/guards/auth-client-crypto.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },

  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },

  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/register.component').then(
        (m) => m.RegisterComponent,
      ),
  },

  {
    path: 'select-code-channel',
    loadComponent: () =>
      import('./pages/select-code-channel/select-code-channel.component').then(
        (m) => m.SelectCodeChannelComponent,
      ),
  },

  {
    path: 'confirm-email',
    loadComponent: () =>
      import('./pages/confirm-email/confirm-email.component').then(
        (m) => m.ConfirmEmailComponent,
      ),
  },

  {
    path: 'register-password',
    loadComponent: () =>
      import('./pages/register-password/register-password.component').then(
        (m) => m.RegisterPasswordComponent,
      ),
  },

  {
    path: 'two-fa',
    loadComponent: () =>
      import('./features/two-fa/two-fa.component').then(
        (m) => m.TwoFaComponent,
      ),
  },

  {
    path: 'kyc-address',
    loadComponent: () =>
      import('./features/kyc-address/kyc-address.component').then(
        (m) => m.KycAddressComponent,
      ),
  },

  {
    path: 'kyc-document-info',
    loadComponent: () =>
      import('./features/kyc-document-info/kyc-document-info.component').then(
        (m) => m.KycDocumentInfoComponent,
      ),
  },

  {
    path: 'kyc-document-capture',
    loadComponent: () =>
      import('./features/kyc-document-capture/kyc-document-capture.component').then(
        (m) => m.KycDocumentCaptureComponent,
      ),
  },

  {
    path: 'kyc-face-capture',
    loadComponent: () =>
      import('./features/kyc-face-capture/kyc-face-capture.component').then(
        (m) => m.KycFaceCaptureComponent,
      ),
  },

  {
    path: 'kyc-preview',
    loadComponent: () =>
      import('./features/kyc-preview/kyc-preview.component').then(
        (m) => m.KycPreviewComponent,
      ),
  },

  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent,
      ),
    canActivate: [AuthClientCryptoGuard],
  },

  {
    path: 'deposit',
    loadComponent: () =>
      import('./features/deposit/deposit.component').then(
        (m) => m.DepositComponent,
      ),
    canActivate: [AuthClientCryptoGuard],
  },

  {
    path: 'convert',
    loadComponent: () =>
      import('./features/convert/convert.component').then(
        (m) => m.ConvertComponent,
      ),
    canActivate: [AuthClientCryptoGuard],
  },

  {
    path: 'convert/confirm/:amount',
    loadComponent: () =>
      import('./features/convert/confirm-convert/confirm-convert.component').then(
        (m) => m.ConfirmConvertComponent,
      ),
    canActivate: [AuthClientCryptoGuard],
  },

  {
    path: 'convert/confirm',
    loadComponent: () =>
      import('./features/convert/confirm-convert/confirm-convert.component').then(
        (m) => m.ConfirmConvertComponent,
      ),
    canActivate: [AuthClientCryptoGuard],
  },

  {
    path: 'withdraw',
    loadComponent: () =>
      import('./features/withdraw/withdraw.component').then(
        (m) => m.WithdrawComponent,
      ),
    canActivate: [AuthClientCryptoGuard],
  },

  {
    path: 'statement',
    loadComponent: () =>
      import('./features/statement/statement.component').then(
        (m) => m.StatementComponent,
      ),
    canActivate: [AuthClientCryptoGuard],
  },

  {
    path: 'profile',
    loadComponent: () =>
      import('./features/profile/profile.component').then(
        (m) => m.ProfileComponent,
      ),
    canActivate: [AuthClientCryptoGuard],
  },

  {
    path: '**',
    redirectTo: 'login',
  },
];